import React, { memo, useState } from 'react';
import Skeleton from 'react-loading-skeleton';
import PropTypes from 'prop-types';
import { Card } from 'react-bootstrap';
import { Link } from 'react-router-dom';

import Image from '@/components/atoms/image';
import styles from './collection-card.module.scss';
import { ImageSizes } from '@/constants/image-sizes.constant';
import CollectionArrow from '@/assets/icons/collection-arrow.svg'
import { useTranslation } from '@/hooks';

const CollectionCardComponent = ({ bgImg, title, description, loading, imageDefault, link, className, fullURL, bodyColor, ...props }) => {
  const { t } = useTranslation();
  const [imageOnError, setImageOnError] = useState(undefined);

  const skeleton = <div className='d-flex flex-column'>
    <Skeleton height={160} width={260} />
    <div className='d-flex'>
      <Skeleton width={40} height={40} className='mr-1' circle />
      <div className='d-flex flex-column'>
        <Skeleton width={155} />
        <Skeleton width={50} />
        <Skeleton count={3} width={215} className='d-block mb-1' />
      </div>
    </div>
  </div>

  const routingProps = () => link && (!fullURL ? ({
    as: Link,
    to: link,
  }) : ({
    as: 'a',
    href: link,
  }));

  const onImageError = () => setImageOnError(imageDefault);

  return loading ? skeleton : (
    <Card {...routingProps()} className={[`${styles.cgCollectionCard}`, className]} {...props}>
      <Image onError={onImageError} className={`${styles.cgCollectionCard__bgImg__size__md__img}`} src={imageOnError || bgImg} alt={description || ''} size={ImageSizes.LARGE} />
      <Card.ImgOverlay className={`${styles.cgCollectionCard__overlayContent}`}>
        <div className={`${styles.cgCollectionCard__title}`}>{title.toUpperCase()}</div>
      </Card.ImgOverlay>
      <Card.Body className={styles.cgCollectionCard__body} style={{ backgroundColor: bodyColor }}>
        <div className={styles.cgCollectionCard__bodyContent}>
          <Card.Text className={styles.cgCollectionCard__bodyText}>{description}</Card.Text>
        </div>
      </Card.Body>
      <div className={styles.cgCollectionCard__bodyHover}>
        <Card.Text className={styles.cgCollectionCard__bodyHoverText}>{t('moleculeTranslations.collectionBanner.hover')}</Card.Text>
        <CollectionArrow className={styles.cgCollectionCard__svg} />
      </div>
    </Card>
  );
};

CollectionCardComponent.propTypes = {
  bgImg: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
  link: PropTypes.string,
  fullURL: PropTypes.bool,
  loading: PropTypes.bool,
  className: PropTypes.any,
  type: PropTypes.any,
  bodyColor: PropTypes.string,
  imageDefault: PropTypes.string
};

export default memo(CollectionCardComponent);
